import { render } from "./OrthoSideBar.vue?vue&type=template&id=f81118d0&scoped=true"
import script from "./OrthoSideBar.vue?vue&type=script&lang=js"
export * from "./OrthoSideBar.vue?vue&type=script&lang=js"

import "./OrthoSideBar.vue?vue&type=style&index=0&id=f81118d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81118d0"]])

export default __exports__